"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'payment.stripe.info': 'Por favor complete el pago usando Stripe Elements a continuación.',
    'payment.stripe.clientSecret': 'Client Secret',
    'payment.stripe.noClientSecret': 'No hay Client Secret de Stripe disponible',
};
